import { useCallback } from 'react'
import ModalSmallFilled from '../../../../../../baseComponents/ModalsLayouts/ModalSmallFilled'
import { ModalEditComponentProps } from '../../../../../../baseComponents/ModalsLayouts/types'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'
import { twinFetchPostJSON } from '../../../../../../utils/globals/data'
import useIsLoading from '../../../../../../utils/hooks/useIsLoading'

interface ModalFinalizeQuoteProps extends ModalFinalizeQuoteLogicProps {
}

const ModalFinalizeQuote: React.FC<ModalFinalizeQuoteProps> = ({ setOpened, onSubmit, allRowData, url }) => {
    const { t } = useTwinTranslation()
    const { handleOnAccept, loading } = useModalFinalizeQuoteLogic({ setOpened, onSubmit, allRowData, url })
    return (
        <ModalSmallFilled opened={true} setOpened={setOpened} onCancel={() => setOpened(null)} onAccept={handleOnAccept} translations={{
            title: t('sureAcceptQuote', '¿Seguro que quieres marcar como aceptado este presupuesto?'),
            subtitle: t('onceAcceptedNoMoreChangesM', 'Una vez aceptado no podrás modificarlo'),
            buttonAccept: t('accept', 'Aceptar'),
        }} loading={loading} />
    )
}

interface ModalFinalizeQuoteLogicProps extends ModalEditComponentProps { 
    url: string
}

const useModalFinalizeQuoteLogic = ({ allRowData, onSubmit, url }: ModalFinalizeQuoteLogicProps) => {
    const { startLoading, endLoading, loading } = useIsLoading()
    const handleOnAccept = useCallback(async () => {
        startLoading?.()
        const result = await twinFetchPostJSON(url, { ...allRowData || {} })
        if (result) {
            onSubmit?.(result, {})
        }
        endLoading?.()
    }, [startLoading, endLoading, onSubmit, allRowData, url])
    return { handleOnAccept, loading }
}

export default ModalFinalizeQuote